import { Box, Typography } from "@mui/material";
import React from "react";
import noData from "../../assets/svg/no-data.svg";

const NoData = ({ title = "No Data Available", height = "240px" }) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      height={height}
    >
      <img src={noData} alt={title} />
      <Typography gutterBottom>{title}</Typography>
    </Box>
  );
};
export default NoData;
